import axios from 'axios';
import { LanguageObject } from '@/i18n';

interface Resource {
  name: string;
  url: string;
}

interface Bookshelf {
  id: number;
  name: LanguageObject;
  notes: string;
  layout: ResourceLayout[];
}

type ResourceLayout = ResourceCategory | ResourceItem;

interface ResourceCategory {
  title: LanguageObject;
  children: ResourceLayout[];
  options: {
    collapsed: boolean;
  };
}

interface ResourceItem {
  type: 'url' | 'text';
  title: LanguageObject;
  description: LanguageObject;
  language: 'any' | 'en' | 'fr';
  value?: string;
}

const resources = {
  list: async (params?: any) => {
    const resp = await axios.get<Resource[]>('/resources/list.php', {
      params: params,
    });
    return resp.data;
  },

  add: async (file: any) => {
    const data = new FormData();
    data.set('document', file);
    const resp = await axios.post<Resource>('/resources/upload.php', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return resp.data;
  },

  edit: async (pristine: Partial<Resource>, item: Partial<Resource>) => {
    const resp = await axios.get<Resource>('/resources/rename.php', {
      params: {
        oldname: pristine.name,
        newname: item.name,
      },
    });
    return resp.data;
  },

  remove: async (name: string) => {
    await axios.delete('/resources/delete.php', {
      params: { name: name },
    });
  },
};

const bookshelf = {
  list: async (params?: any) => {
    const resp = await axios.get<Bookshelf[]>('/bookShelves/list.php', {
      params: params,
    });
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<Bookshelf>('/bookShelves/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (bookshelf: Partial<Bookshelf>) => {
    const resp = await axios.post<Bookshelf>('/bookShelves/add.php', bookshelf);
    return resp.data;
  },

  update: async (bookshelf: Partial<Bookshelf>) => {
    const resp = await axios.post<Bookshelf>(
      '/bookShelves/update.php',
      bookshelf
    );
    return resp.data;
  },

  remove: async (id: number) => {
    await axios.delete('/bookShelves/delete.php', {
      params: { id: id },
    });
  },
};

export default {
  api: {
    resource: resources,
    bookshelf: bookshelf,
  },
};

export { Resource, Bookshelf, ResourceLayout, ResourceItem, ResourceCategory };
